import { Instagram, BookMarked } from "lucide-react";
import { socialLinks } from "@/lib/api";

// Small inline brand mark — lucide-react doesn't ship a TikTok icon
const TikTokMark = ({ size = 16 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V7.82a8.16 8.16 0 0 0 4.77 1.53V5.9a4.85 4.85 0 0 1-1.84-.21z"/>
  </svg>
);

/**
 * Rounded social icon buttons — hide channels with no stored value.
 * variant: "footer" (bordered pill) | "home" (filled soft lavender).
 */
export default function SocialIcons({ settings, variant = "footer", testPrefix = "social-icon" }) {
  const sl = socialLinks(settings || {});
  const items = [
    sl.instagram && { key: "instagram", label: `Instagram @${sl.instagramUsername}`, href: sl.instagram, mark: <Instagram size={16} strokeWidth={1.4} /> },
    sl.tiktok && { key: "tiktok", label: `TikTok @${sl.tiktokUsername}`, href: sl.tiktok, mark: <TikTokMark size={14} /> },
    sl.xiaohongshu && { key: "xiaohongshu", label: "Xiaohongshu (Little Red Book)", href: sl.xiaohongshu, mark: <BookMarked size={15} strokeWidth={1.4} /> },
  ].filter(Boolean);

  if (!items.length) return null;

  const base = "w-10 h-10 flex items-center justify-center rounded-full transition-all duration-300";
  const styleFor = (v) => v === "home"
    ? { background: "#EBE5ED", color: "#4A464A" }
    : { border: "1px solid #4A464A", color: "#4A464A", background: "transparent" };

  return (
    <div className="flex items-center gap-3" data-testid={testPrefix}>
      {items.map(it => (
        <a key={it.key}
           href={it.href}
           target="_blank"
           rel="noreferrer"
           aria-label={it.label}
           title={it.label}
           data-testid={`${testPrefix}-${it.key}`}
           className={`${base} hover:scale-110 hover:bg-[#4A464A] hover:text-[#FDFBF7] hover:border-[#4A464A]`}
           style={styleFor(variant)}>
          {it.mark}
        </a>
      ))}
    </div>
  );
}
